
(() => {
  if (window.snowfallInitialized) return;
  window.snowfallInitialized = true;

  const canvas = document.createElement('canvas');
  canvas.id = 'christmas-snowfall';

  Object.assign(canvas.style, {
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '9998'
  });

  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  let width, height;
  let flakes = [];
  let animation;

  const mobile = window.innerWidth < 768;
  const totalFlakes = mobile ? 30 : 45;

  function resize() {
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
  }

  function createFlake(randomY = true) {
    return {
      x: Math.random() * width,
      y: randomY ? Math.random() * height : -15,
      size: Math.random() * 2 + 1.5,
      speed: Math.random() * 0.9 + 0.6,
      drift: Math.random() * 0.7 - 0.35,
      opacity: Math.random() * 0.4 + 0.45
    };
  }

  function drawSnowflake(flake) {
    ctx.save();

    ctx.beginPath();
    ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);

    ctx.fillStyle = `rgba(184, 220, 236, ${flake.opacity})`;

    ctx.shadowBlur = 4;
    ctx.shadowColor = 'rgba(184, 220, 236, 0.5)';

    ctx.fill();

    ctx.restore();
  }

  function init() {
    resize();

    flakes = Array.from(
      { length: totalFlakes },
      () => createFlake()
    );
  }

  function draw() {
    ctx.clearRect(0, 0, width, height);

    flakes.forEach((flake, index) => {
      flake.y += flake.speed;
      flake.x += flake.drift;

      drawSnowflake(flake);

      if (flake.y > height + 20) {
        flakes[index] = createFlake(false);
      }

      if (flake.x > width + 20) flake.x = -20;
      if (flake.x < -20) flake.x = width + 20;
    });

    if (!document.hidden) {
      animation = requestAnimationFrame(draw);
    }
  }

  document.addEventListener('visibilitychange', () => {
    cancelAnimationFrame(animation);

    if (!document.hidden) {
      animation = requestAnimationFrame(draw);
    }
  });

  window.addEventListener('resize', resize);

  init();
  draw();
})();
